const WATERMARK_LINES = [
	"This Genogram was ",
	"Built With Qwoach.",
	"",
	"To Remove This Watermark,",
	"Please Save This Genogram First."
]
const WATERMARK_FONT_SIZE_PX = 50
const WATERMARK_LINE_HEIGHT_PX = WATERMARK_FONT_SIZE_PX
const WATERMARK_COLOR = "rgba(60, 60, 60, 0.4)"
const WATERMARK_QUADRANT_WIDTH = 900
const WATERMARK_QUADRANT_HEIGHT = 400

export default class GenogramWatermarkPatternBuilder {

	buildPattern() {
		let canvas = document.createElement("canvas")
		let ctx = canvas.getContext("2d", {willReadFrequently: true})
		let watermarkTextHeight = WATERMARK_LINE_HEIGHT_PX * WATERMARK_LINES.length
		canvas.width = WATERMARK_QUADRANT_WIDTH
		canvas.height = WATERMARK_QUADRANT_HEIGHT
		ctx.clearRect(0, 0, canvas.width, canvas.height)
		ctx.fillStyle = WATERMARK_COLOR
		ctx.font = `${WATERMARK_FONT_SIZE_PX}px Arial`

		let lineIndex = 0
		for (let line of WATERMARK_LINES) {
			let {width} = ctx.measureText(line)
			let x = (WATERMARK_QUADRANT_WIDTH - width) / 2
			let y = (WATERMARK_QUADRANT_HEIGHT - watermarkTextHeight) / 2 + lineIndex * WATERMARK_LINE_HEIGHT_PX
			ctx.fillText(line, x, y)
			lineIndex++
		}

		let imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)

		return {
			width: canvas.width,
			height: canvas.height,
			data: imageData.data,
		}
	}
}
